// Orders area — list, kanban, new-order wizard, order detail + its panels.
export const orders = {
  pax: {
    adults_one: "{{count}} adult",
    adults_few: "{{count}} adults",
    adults_other: "{{count}} adults",
    children_one: "{{count}} child",
    children_few: "{{count}} children",
    children_other: "{{count}} children",
  },
  list: {
    title: "Orders",
    subtitle: "Manage inquiries and orders",
    newOrder: "New order",
    tableView: "Table",
    kanbanView: "Kanban",
    statNewInquiries: "New inquiries",
    statAwaitingPayment: "Awaiting payment",
    statFullyPaid: "Fully paid",
    statTotalValue: "Total value",
    searchPlaceholder: "Search by order #, customer, email, or trip…",
    facetAgent: "Agent",
    unassigned: "Unassigned",
    empty: "No orders found",
    colOrder: "Order",
    details: "Details",
  },
  kanban: {
    title: "Orders Kanban",
    subtitle: "Drag and drop cards to change order status",
    loadError: "Error loading orders.",
    cancelledHidden_one: "{{count}} cancelled order (not shown in kanban)",
    cancelledHidden_few: "{{count}} cancelled orders (not shown in kanban)",
    cancelledHidden_other: "{{count}} cancelled orders (not shown in kanban)",
    emptyColumn: "No orders",
    ppl: "{{n}} ppl",
    priceLabel: "Price:",
  },
  new: {
    title: "New order",
    subtitle: "Manual order creation",
    steps: {
      trip: "Trip",
      customer: "Customer",
      details: "Details",
      review: "Summary",
    },
    leadDepartureNotRunning:
      "The inquiry's departure ({{date}}) is not running, pick another date.",
    hotel: {
      title: "Hotel stay requested in the inquiry",
      stay: "Stay",
      nights_one: "{{count}} night",
      nights_few: "{{count}} nights",
      nights_other: "{{count}} nights",
      room: "Room",
      meal: "Board",
      departure: "Departure from",
      included: "included",
    },
    selectTripTitle: "Select trip and date",
    searchTrips: "Search trips...",
    days_one: "{{count}} day",
    days_few: "{{count}} days",
    days_other: "{{count}} days",
    requestedDate: "Requested date",
    anyDayHint: "Customer can pick any day for this experience.",
    availableDates: "Available dates",
    spots_one: "{{count}} spot",
    spots_few: "{{count}} spots",
    spots_other: "{{count}} spots",
    noActiveDates: "No active dates",
    continue: "Continue",
    existingCustomer: "Existing customer",
    newCustomer: "New customer",
    searchCustomers: "Search by name, email, or phone...",
    customerNotFound: "Customer not found.",
    createNew: "Create new",
    firstNameRequired: "First name *",
    lastNameRequired: "Last name *",
    emailRequired: "Email *",
    street: "Street",
    city: "City",
    zip: "ZIP code",
    createCustomer: "Create customer",
    selectedCustomer: "Selected customer: {{name}} ({{email}})",
    detailsTitle: "Order details",
    adultsCount: "Number of adults",
    childrenCount: "Number of children (under 12)",
    travelers: "Travelers",
    travelerPlaceholder: "Traveler {{n}} name",
    initialStatus: "Initial order status",
    customerNotes: "Customer notes",
    customerNotesPlaceholder: "Special requests, preferences...",
    internalNotes: "Internal notes",
    internalNotesPlaceholder: "Notes for internal use...",
    reviewTitle: "Order summary",
    anyDayDate: "{{date}} (any-day)",
    hours_one: "{{count}} hour",
    hours_few: "{{count}} hours",
    hours_other: "{{count}} hours",
    adultsAtPrice: "{{n}}x adult @ {{price}}",
    childrenAtPrice: "{{n}}x child (50%) @ {{price}}",
    depositHalf: "Deposit (50%)",
    notesCustomer: "Customer:",
    notesInternal: "Internal:",
    creating: "Creating...",
    createOrder: "Create order",
    createFailed: "Failed to create order. Please try again.",
  },
  detail: {
    loadError: "Error loading order.",
    orderNumber: "Order #{{id}}",
    createdAt: "Created: {{date}}",
    cancelledBanner: "This order has been cancelled",
    workflow: {
      inquiry: "Inquiry",
      quoted: "Quoted",
      confirmed: "Confirmed",
      deposit: "Deposit",
      paid: "Paid",
      completed: "Completed",
    },
    paymentAwaiting: "Awaiting payment",
    paymentDeposit: "Deposit paid",
    paymentFull: "Fully paid",
    requestedDate: "Requested: {{date}}",
    hoursShort: "{{hours}}h",
    priceBreakdown: "Price breakdown",
    pricePersons_one: "Price x {{count}} person",
    pricePersons_few: "Price x {{count}} persons",
    pricePersons_other: "Price x {{count}} persons",
    deposit: "Deposit",
    viewProfile: "View profile",
    keyDates: "Key dates",
    depositDue: "Deposit due",
    balanceDue: "Balance due",
    departure: "Departure",
    attribution: "Attribution",
    source: "Source",
    adClick: "Ad click",
    utmSource: "UTM source",
    utmMedium: "UTM medium",
    utmCampaign: "UTM campaign",
    lead: "Lead",
    viewLead: "View lead",
    customerNotes: "Customer notes",
  },
  margin: {
    title: "Margin",
    revenue: "Revenue",
    supplierCost: "Supplier cost",
    margin: "Margin",
  },
  whatsDifferent: {
    title: "What's different about this order",
    subtitle: "Deviations from the standard package — these flow to the guide.",
  },
  items: {
    title: "Order items",
    suggestFromNotes: "Suggest from notes",
    suggestTitle: "Propose items from the customer's notes",
    saveItems: "Save items",
    nothingToAdd:
      "Nothing to add from the notes. Paste a transcript below, or the request had no customizations.",
    aiProposed_one: "AI proposed {{count}} item:",
    aiProposed_few: "AI proposed {{count}} items:",
    aiProposed_other: "AI proposed {{count}} items:",
    setPrice: "set price",
    reviewPrices: "— review prices, then Save items.",
    hidePaste: "Hide",
    pasteToggle: "Paste call / Plaud notes instead…",
    pastePlaceholder:
      "Paste call notes / a Plaud transcript — e.g. 'wants 5-star hotel, add a Halong sunset cruise for 2'…",
    suggestFromText: "Suggest from this text",
  },
  confirmations: {
    title: "Incoming confirmations",
    scanInbox: "Scan inbox",
    hint: "AI reads PDF attachments from this order's emails and suggests which booking each confirms.",
    noPdfs: "No PDF attachments found on this order's emails.",
    truncated: "More attachments exist than were scanned (showing the first 5).",
    unreadable: "Couldn't read fields from this PDF",
    attach: "Attach",
    attached: "Attached ✓",
    noBookings: "No bookings on this order to attach to.",
  },
  participants: {
    title: "Participants",
    revealTitle: "Reveal passport numbers (logged)",
    hideTitle: "Hide passport numbers",
    revealPassports: "Reveal passports",
    hidePassports: "Hide passports",
    restricted: "Passport numbers are restricted for your role.",
    firstName: "First name",
    lastName: "Last name",
    nationality: "Nationality",
    birthDate: "Birth date",
    passportNo: "Passport no.",
    passportExpiry: "Passport expiry",
    genderTitle: "Gender (arrival-card portals require it)",
    genderEmpty: "Gender —",
    male: "Male",
    female: "Female",
    otherGender: "Other",
    occupation: "Occupation (entry forms)",
    dietary: "Dietary / notes",
    leadPax: "Lead",
    removeTitle: "Remove participant",
    add: "Add participant",
  },
  audit: {
    title: "Audit trail",
    empty: "No audit events yet.",
    system: "System",
  },
  calculation: {
    title: "Calculation (pricing)",
  },
  cancellation: {
    cancelledTitle: "Cancelled",
    stornoFee: "Storno fee",
    refundToCustomer: "Refund to customer",
    supplierLoss: "Supplier loss",
    netImpact: "Net impact",
    reason: "Reason",
    title: "Cancel order",
    start: "Start cancellation",
    daysToDeparture: "Days to departure",
    policyFee: "Policy fee",
    effectiveFee: "Effective fee",
    paidSoFar: "Paid so far",
    refundDue: "Refund due",
    servicesToCancel: "Services to cancel",
    waiveFee: "Waive fee (%)",
    reasonPlaceholder: "Reason (optional)",
    confirm: "Confirm cancellation",
  },
  timeline: {
    types: {
      email: "Email",
      phone: "Phone",
      note: "Note",
      sms: "SMS",
      statusChange: "Status Change",
      payment: "Payment",
      document: "Document",
    },
    title: "Communication",
    reply: "Reply",
    addEntry: "Add Entry",
    replyToPrefix: "Reply to",
    replyViaMailbox: "via your connected mailbox.",
    replyViaMailboxThreaded: "via your connected mailbox (threaded).",
    subjectPlaceholder: "Subject",
    replyPlaceholder: "Write your reply…",
    sendFailed: "Send failed",
    sendReply: "Send reply",
    defaultReplySubject: "Re: your inquiry",
    internalNoteSubject: "Internal note",
    notePlaceholder: "Write an internal note... (type @ to mention a colleague)",
    phonePlaceholder: "Phone call summary...",
    emailPlaceholder: "Communication content...",
    subjectInputPlaceholder: "Subject...",
    empty: "No communication yet",
    inbound: "inbound",
    outbound: "outbound",
    less: "Less",
    more: "More",
  },
  complaints: {
    title: "Complaints",
    new: "New",
    whatPlaceholder: "What's the complaint?",
    compensationPlaceholder: "Compensation",
    add: "Add complaint",
    empty: "No complaints.",
    compensationToPay: "Compensation to pay (optional)",
    issueCreditNote: "Issue a credit note",
    resolutionNote: "Resolution note",
    resolveRefund: "Resolve & refund",
    resolve: "Resolve",
  },
  documents: {
    title: "Documents",
    contract: "Contract",
    itinerary: "Itinerary",
    offerPdf: "Offer PDF",
    offerTitle: "Compose the offer PDF from the trip, active calculation, flights and country KB",
    check: "Check",
    checkTitle: "Check the offer for inconsistencies (dates, flights, prices) before sending",
    insurancePdf: "Insurance PDF",
    insuranceTitle: "Upload the insurer's policy PDF and attach it to this order",
    offerConsistent: "✓ Offer is consistent — no findings.",
    empty: "No documents yet.",
    createdAt: "Created {{date}}",
    signedAt: "Signed {{date}}",
    sendForSignature: "Send for signature",
    openPdf: "Open PDF",
    copySignLink: "Copy signing link",
  },
  invoices: {
    title: "Invoices & payments",
    proforma: "Proforma",
    final: "Final",
    empty: "No invoices issued yet.",
    due: "due {{date}}",
    openPdf: "Open PDF",
    payments: "Payments",
  },
  portal: {
    title: "Customer portal",
    hint: "Share a magic link — no login. The link is shown once; copy it to send to the customer.",
    regenerate: "Regenerate",
    createLink: "Create link",
    copyLink: "Copy link",
    openLink: "Open link",
    offerRow: "Offer page (quote + accept)",
    portalRow: "Portal (passports + payment)",
  },
  passports: {
    chipPnrOk: "PNR ✓",
    chipFuzzy: "check spelling",
    chipMissing: "not on PNR",
    chipNoPnr: "no PNR yet",
    photoRestricted: "photo restricted",
    scanAlt: "Passport scan",
    title: "Passports & ticket check",
    scansToConfirm_one: "{{count}} scan to confirm",
    scansToConfirm_few: "{{count}} scans to confirm",
    scansToConfirm_other: "{{count}} scans to confirm",
    uploadTitle: "Upload a passport photo — MRZ is read and offered as a confirmable diff",
    upload: "Upload passport photo",
    ticketCheck: "Ticket check",
    checkSummary: "{{match}}/{{pax}} matched · {{checked}} checked",
    ticket: "ticket: {{name}}",
    noPassport: "no passport",
    expiresTooSoon: "expires {{date}} — too soon",
    checkedTitle: "Checked — click to clear",
    markCheckedTitle: "Mark name/DOB verified against the ticket (checked by + date)",
    checked: "checked",
    markChecked: "mark checked",
    unmatchedPnr: "On the PNR but not among participants: {{names}}",
    via: "via {{source}}",
    name: "Name",
    passport: "Passport",
    bornExpires: "Born / expires",
    nationality: "Nationality",
    mrzUnreadable:
      "MRZ unreadable or checksums failed — read the photo and type the data into the participant manually, then reject this scan.",
    assignTraveller: "Assign to traveller…",
    confirmIntoTraveller: "Confirm into traveller",
    reject: "Reject",
    pastePnr: "Paste PNR (Amadeus)",
    pnrHint: "Paste the raw Amadeus display — segments & names are parsed for you",
    parse: "Parse",
    attachToFlight: "Attach to flight booking…",
    pax: "Pax: {{names}}",
    locator: "Locator: {{locator}}",
    ignoredLines: "Ignored lines: {{n}}",
    noSegments: "No flight segments recognised — check the paste.",
  },
  statusActions: {
    amount: "Amount (CZK)",
    noteOptional: "Note (optional)",
    notePlaceholder: "E.g. reference number, payment date...",
    recordPayment: "Record payment",
    sendOffer: "Send offer",
    resendOffer: "Resend offer",
    confirmOrder: "Confirm order",
    recordDeposit: "Record deposit",
    recordBalance: "Record balance payment",
    markCompleted: "Mark as completed",
    sendOfferMessage:
      "A personalised offer email with an online quote link will be sent to the customer, and the order will move to Quoted. Continue?",
    confirmMessage:
      "The order will be confirmed and an email with payment instructions will be sent to the customer.",
    completeMessage: "The order will be marked as completed.",
    complete: "Complete",
    cancelMessage: "Are you sure you want to cancel this order? This action cannot be undone.",
    cancelOrder: "Cancel order",
    capacityTitle: "Capacity will be exceeded",
    capacityMessage:
      "This will exceed capacity ({{booked}}/{{capacity}} booked, +{{pax}} new = {{total}}). Confirm anyway?",
    confirmAnyway: "Confirm anyway",
    offerSent: "Offer sent {{date}}",
    viewed: "viewed {{date}}",
    notViewed: "· not viewed yet",
    sendOfferFailed: "Could not send the offer",
  },
};
